import { render, staticRenderFns } from "./ExportConfig.vue?vue&type=template&id=37c966e3&scoped=true"
import script from "./ExportConfig.vue?vue&type=script&lang=js"
export * from "./ExportConfig.vue?vue&type=script&lang=js"
import style0 from "./ExportConfig.vue?vue&type=style&index=0&id=37c966e3&prod&lang=scss"
import style1 from "./ExportConfig.vue?vue&type=style&index=1&id=37c966e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c966e3",
  null
  
)

export default component.exports